<template>
  <div>
    <div v-if="property">
      <v-navigation-drawer app right floating clipped>
        <div class="pa-8 py-6">
          <div class="d-flex flex-column align-center mb-4">
            <a id="logo-trigger">
              <v-avatar color="grey" size="100" class="logo">
                <img
                  v-if="property.logo"
                  class="logo-img"
                  :src="property.logo"
                  :alt="property.propertyName"
                />
                <v-icon v-else dark x-large>mdi-camera</v-icon>
              </v-avatar>
            </a>
          </div>
          <p class="title-1 font-weight-bold">
            {{ property.propertyName }}
          </p>
          <p class="caption">{{ property.address1 }}</p>
          <p class="caption">{{ property.address2 }}</p>

          <v-divider class="my-8"></v-divider>

          <div class="d-flex flex-row">
            <v-icon small>mdi-calendar</v-icon>
            <p class="mb-0 ml-2 caption">License Expiration</p>
          </div>
          <p class="subtitle-1 font-weight-bold">
            {{ getSubscriptionExpireText() }}
          </p>

          <!-- <div class="d-flex mt-4 flex-row">
            <v-icon small>mdi-garage-alert</v-icon><p class="mb-0 ml-2 caption">Unit Limit</p>
          </div>
          <p class="subtitle-1 font-weight-bold">{{property.unitLimit}} Units</p> -->

          <div class="d-flex mt-4 flex-row">
            <v-icon small>mdi-account-alert-outline</v-icon>
            <p class="mb-0 ml-2 caption">Manager Limit</p>
          </div>
          <p class="subtitle-1 font-weight-bold">
            {{ property.userLimit }} Users
          </p>

          <div class="d-flex mt-4 flex-row">
            <v-icon small>mdi-account-alert-outline</v-icon>
            <p class="mb-0 ml-2 caption">SMS Notifications</p>
          </div>
          <p class="subtitle-1 font-weight-bold">
            {{ property.sendSMS ? 'Active' : 'Inactive' }}
          </p>

          <div class="d-flex mt-4 flex-row">
            <v-icon small>mdi-account-alert-outline</v-icon>
            <p class="mb-0 ml-2 caption">Online Payment</p>
          </div>
          <p class="subtitle-1 font-weight-bold">
            {{ property.payOnline ? 'Active' : 'Inactive' }}
          </p>
        </div>
        <template v-slot:append>
          <div class="d-flex justify-center">
            <v-btn
              class="my-5 font-weight-bold"
              color="primary"
              text
              :disabled="!access.update"
              @click="updateProperty"
              ><v-icon class="mr-1">mdi-cog-outline</v-icon>Settings</v-btn
            >
          </div>
        </template>
      </v-navigation-drawer>

      <v-container class="mx-12 my-6">
        <div v-if="access.create" class="mb-8">
          <div class="card-label d-flex flex-row mb-4">
            <v-icon>mdi-account-plus</v-icon>
            <p class="mb-0 ml-4 subtitle-2 font-weight-bold">
              Assign a New Page Role
            </p>
          </div>
          <v-row>
            <v-col cols="12" sm="7" md="7" class="py-0">
              <v-text-field
                v-model="username"
                name="username"
                label="Username or E-mail"
                :loading="loading"
                prepend-inner-icon="mdi-account"
                solo
                flat
                dense
                hide-details
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3" class="py-0">
              <v-select
                v-model="selectedRole"
                :items="roleSelect"
                label="Role"
                solo
                flat
                dense
                hide-details
              ></v-select>
            </v-col>
            <v-col
              cols="12"
              sm="2"
              md="2"
              class="d-flex flex-row py-0 align-center"
            >
              <v-btn
                class="font-weight-bold"
                rounded
                depressed
                block
                small
                color="primary"
                @click="addUserToProperty"
              >
                <v-icon class="pr-1" small>mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
          </v-row>
          <!-- <v-row v-if="selectedRole">
            <v-col>
              <p class="caption grey--text">{{getRoleDesc(selectedRole)}}</p>
            </v-col>
          </v-row> -->
        </div>

        <div class="card-label d-flex flex-row mb-4">
          <v-icon>mdi-account-multiple</v-icon>
          <p class="mb-0 ml-4 subtitle-2 font-weight-bold">
            Existing Page Roles
          </p>
        </div>
        <v-card class="card-content pa-6 mb-8" elevation="0">
          <v-list class="existing-page-roles-list" two-line>
            <template v-for="(item, index) in property.user_details">
              <div :key="index">
                <v-list-item>
                  <v-list-item-avatar color="grey">
                    <v-img
                      v-if="item.profilePicture"
                      :src="item.profilePicture"
                    ></v-img>
                    <v-icon v-else dark small>mdi-account</v-icon>
                  </v-list-item-avatar>

                  <div
                    style="width: 100%"
                    class="d-flex flex-row justify-space-between"
                  >
                    <div>
                      <v-list-item-title
                        ><p class="body-2">
                          {{ getUserName(item) }}
                        </p></v-list-item-title
                      >
                      <v-list-item-subtitle class="d-flex flex-row">
                        <p class="caption">{{ getRole(index) }}</p>
                        <!-- <v-tooltip right max-width="400">
                          <template v-slot:activator="{ on }">
                            <v-icon small class="ml-1" v-on="on">mdi-help-circle</v-icon>
                          </template> -->
                        <!-- <p class="caption white--text">{{getRoleSummary(updateSelectedRole[index])}}</p> -->
                        <!-- </v-tooltip> -->
                      </v-list-item-subtitle>
                    </div>
                    <div>
                      <v-row v-if="editItems[index] === true">
                        <v-col cols="12" sm="3" md="3" class="py-0"></v-col>
                        <v-col cols="12" sm="4" md="4" class="py-0">
                          <v-select
                            v-model="updateSelectedRole[index]"
                            :items="roleSelect"
                            label="Role"
                            outlined
                            dense
                            hide-details
                          ></v-select>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="2"
                          md="2"
                          class="py-0 d-flex align-center"
                        >
                          <v-btn
                            rounded
                            depressed
                            :disabled="
                              !access.update || updateSelectedRole[index] === ''
                            "
                            color="primary"
                            small
                            @click="
                              updateUserRole(item, updateSelectedRole[index])
                            "
                            >Update</v-btn
                          >
                        </v-col>
                        <v-col
                          cols="12"
                          sm="2"
                          md="2"
                          class="py-0 d-flex align-center"
                        >
                          <v-btn
                            rounded
                            depressed
                            :disabled="!access.delete"
                            color="error"
                            small
                            @click="deleteUserRole(item)"
                            >Delete</v-btn
                          >
                        </v-col>
                        <v-col
                          cols="12"
                          sm="1"
                          md="1"
                          class="py-0 d-flex align-center"
                        >
                          <a @click="editUser(index, false)"
                            ><v-icon>mdi-close</v-icon></a
                          >
                        </v-col>
                      </v-row>
                      <v-btn
                        v-if="!editItems[index]"
                        class="font-weight-bold"
                        small
                        rounded
                        depressed
                        :disabled="!access.update"
                        color="primary"
                        @click="editUser(index, true)"
                      >
                        <v-icon x-small class="pr-1">mdi-pencil</v-icon>
                        Edit
                      </v-btn>
                    </div>
                  </div>
                </v-list-item>
                <!-- <v-banner v-if="editItems[index] === true" class="px-4 pt-0">
                    <v-avatar
                      slot="icon"
                      color="grey lighten-2"
                      size="30"
                    >
                      <v-icon
                        icon="mdi-lock"
                        color="white"
                        small
                      >
                        mdi-lock
                      </v-icon>
                    </v-avatar>
                    <p class="caption grey--text">{{getRoleDesc(updateSelectedRole[index])}}</p>
                  </v-banner> -->
              </div>
            </template>
          </v-list>
        </v-card>

        <div class="card-label d-flex flex-row mb-4">
          <v-icon>mdi-book</v-icon>
          <p class="mb-0 ml-4 subtitle-2 font-weight-bold">Property Log</p>
        </div>
        <v-card class="card-content pa-6" elevation="0">
          <v-data-table
            :headers="propertyLogHeaders"
            :items="propertyLogs"
            :items-per-page="10"
            :options.sync="options"
            :server-items-length="propertyLogsTotal"
            dense
            :footer-props="{ 'items-per-page-options': [10, 20, 50, 100] }"
          >
            <template v-slot:item="{ item }">
              <tr class="tr-head">
                <td>
                  <p class="caption">{{ getUserName(item.tenant_details) }}</p>
                </td>
                <td>
                  <p class="caption">{{ parseDate(item.date) }}</p>
                </td>
                <td>
                  <p class="caption">{{ item.log }}</p>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-container>
      <avatar-cropper
        v-if="access.update"
        trigger="#logo-trigger"
        :upload-handler="logoUploadHandler"
        :labels="cropperLabels"
        @error="croppperErrorHandler"
      />
    </div>
    <UpdateProperty ref="updateProperty"></UpdateProperty>
    <v-snackbar v-model="snackbar">
      {{ snackbarText }}
      <v-btn text color="primary" @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { dayjs } from '../util/date'
import AvatarCropper from 'vue-avatar-cropper'
import UpdateProperty from '../components/property/UpdateProperty.vue'

export default {
  components: {
    AvatarCropper,
    UpdateProperty
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      cropperLabels: {
        submit: 'Submit',
        cancel: 'Cancel'
      },
      username: '',
      roles: [],
      roleSelect: [],
      selectedRole: '',
      loading: true,
      snackbar: false,
      snackbarText: '',
      // propertyLogs: [],
      editItems: [],
      property: null,
      updateSelectedRole: [],
      adminSummary: 'Give full access to all features.',
      managerSummary:
        'Give limited access to financials such as Payment Reports and Statement of Accounts.',
      moderatorSummary:
        'Give limited access to updating data such as tenant lease contract, property organization, and announcements',
      adminDesc:
        'Can view dashboards and financial graphs; view calendar; view, update, create, and delete units, view and update status of complaints; view and create violations; view, create, update, and cancel reservations; view, create, waive, and void payments and payment requests; generate payment reports; generate statement of account; view tenants and their details; move in and evict tenants; view and create links; view and create announcements; view and update property information; add or delete property managers; set property user roles; view, create, update, and delete custom notifications.',
      managerDesc:
        'Can view dashboards; view calendar; view, update, create, and delete units; view and update status of complaints; view and create violations; view, create, update, and cancel reservations; view, create, update, void, and cancel payment requests; view paid payments; generate statement of account; view tenants and their details; Move in, transfer, and evict tenants; view and create links; view and create announcements; view property information; view custom notifications.',
      moderatorDesc:
        'Can view dashboards; view calendar; view units; view and update status of complaints; view violations; view, create, update, and cancel reservations; view tenants and their details; view and create links; view announcements; view property information; view custom notifications.',
      options: {},
      propertyLogsTotal: 0
    }
  },
  computed: {
    propertyLogHeaders() {
      return this.$store.getters['properties/getPropertyLogHeaders']
    },
    access() {
      return this.$root.$roleAccess('property').access
    },
    propertyLogs() {
      return this.$store.getters['properties/getPropertyLogs']
    },
    selectedRoleText() {
      return this.roles.find(({ roleId }) => roleId === this.selectedRole).role
    }
  },
  watch: {
    options: {
      async handler() {
        await this.fetchPropertyLogs()
      }
    }
  },
  async mounted() {
    await this.$store.dispatch('properties/fetchPropertyAction')
    await this.fetchPropertyLogs()
    this.property = this.$store.getters['properties/getProperty']

    this.property.user_details.map((user, index) => {
      this.editItems.push(false)
      this.updateSelectedRole.push(this.property.users[index].roleId)
    })

    const rolesInfo = await this.$store.dispatch('roles/getAllRoles') //for roles and checkboxes for roles
    this.roles = rolesInfo.roles
    this.roles.forEach((role) => {
      this.roleSelect.push({
        value: role.roleId,
        text: role.role
      })
    })

    this.loading = false
  },
  methods: {
    croppperErrorHandler(message) {
      this.$log.error(message)
    },
    logoUploadHandler(cropper) {
      this.loading = true
      cropper.getCroppedCanvas().toBlob(async (blob) => {
        try {
          await this.$store.dispatch('properties/updatePropertyLogoAction', {
            logo: blob
          })
          this.loading = false
          window.location.reload()
        } catch (err) {
          this.loading = false
          this.snackbarText = err
          this.snackbar = true
        }
      })
    },
    async addUserToProperty() {
      await this.$store.dispatch('users/fetchSelectedUserAction', {
        username: this.username
      })
      this.userDetails = this.$store.getters['users/getSelectedUser']

      if (this.userDetails) {
        if (!this.selectedRole) {
          this.snackbarText = 'Please select a role'
          this.snackbar = true
        } else if (
          this.property.user_details.find((user) => {
            return (
              user.username === this.username || user.email1 === this.username
            )
          })
        ) {
          this.snackbarText = 'User already has a role in your property'
          this.snackbar = true
        } else if (
          await this.$root.$confirm({
            title: 'Add User to Property',
            message: `Are you sure you would like to add ${this.getUserName(
              this.userDetails
            )} as ${this.selectedRoleText}?`,
            options: {
              color: 'primary'
            }
          })
        ) {
          this.loading = true
          try {
            await this.$store.dispatch('properties/addUserPropertyAction', {
              username: this.username,
              roleId: this.selectedRole
            })
            // this.$router.go()
            this.loading = false
            window.location.reload()
          } catch (err) {
            this.snackbarText = err
            this.snackbar = true
            // console.log(err)
          }
          this.loading = false
        }
      } else {
        this.snackbarText = 'Username does not exist'
        this.snackbar = true
      }
    },
    getUserName(user) {
      if (!user) return 'System'
      let name = ''
      if (user.firstName) {
        name += user.firstName + ' '
      }
      if (user.lastName) {
        name += user.lastName + ' '
      }
      if (user.username) {
        name += `(${user.username})`
      }
      return name
    },
    getRole(index) {
      const user = this.property.users[index]
      const roleId = user.roleId
      const role = this.roles.find((role) => role.roleId === roleId)

      return role && role.role
    },
    //get role of current user
    getCurrentRole() {
      const user = this.$store.getters['auth/getUser']
      const role = user.role_details.find(
        ({ propertyId }) => propertyId === this.property.propertyId
      )

      return role && role.role
    },
    getSubscriptionExpireText() {
      return dayjs(this.property.subscriptionEnd).format('MMMM DD, YYYY')
    },
    parseDate(date) {
      return dayjs(date).format('MMMM DD, YYYY')
    },
    editUser(index, value) {
      this.$set(this.editItems, index, value)
    },
    async deleteUserRole(user) {
      try {
        const confirm = await this.$root.$confirm({
          title: 'Remove User',
          message: `Are you sure you want to remove ${this.getUserName(
            user
          )} from your property?`,
          confirmText: 'Yes'
        })

        if (confirm) {
          this.loading = true
          await this.$store.dispatch('properties/removeUserPropertyAction', {
            userId: user.userId
          })
          this.snackbarText = `${this.getUserName(user)} has been removed.`
          this.snackbar = true
          this.loading = false
          window.location.reload()
        } else {
          this.loading = false
        }
      } catch (err) {
        this.snackbarText = err.data
        this.snackbar = true
        this.loading = false
      }
    },
    async updateUserRole(user, roleId) {
      try {
        const newRole = this.roles.find(
          (matchedRole) => matchedRole.roleId === roleId
        )
        const role = newRole && newRole.role

        const confirm = await this.$root.$confirm({
          title: 'Update User',
          message: `Are you sure you want to update ${this.getUserName(
            user
          )} to ${role} role?`,
          confirmText: 'Yes'
        })

        if (confirm) {
          this.loading = true
          await this.$store.dispatch('properties/updateUserPropertyAction', {
            userId: user.userId,
            roleId: roleId
          })
          this.snackbarText = `${this.getUserName(
            user
          )} has been update to ${role}.`
          this.snackbar = true
          this.loading = false
          // this.$router.go()
          window.location.reload()
        } else {
          this.loading = false
        }
      } catch (err) {
        this.snackbarText = err.data
        this.snackbar = true
        this.loading = false
      }
    },
    updateProperty() {
      this.$refs.updateProperty.open(this.property)
    },
    // getRoleDesc(role) {
    //   switch(role) {
    //     case 'owner':
    //       return this.adminDesc
    //     case 'admin':
    //       return this.adminDesc
    //     case 'manager':
    //       return this.managerDesc
    //     case 'moderator':
    //       return this.moderatorDesc
    //     default:
    //       return ''
    //   }
    // },
    // getRoleSummary(role) {
    // switch(role) {
    //   case 'owner':
    //     return this.adminSummary
    //   case 'admin':
    //     return this.adminSummary
    //   case 'manager':
    //     return this.managerSummary
    //   case 'moderator':
    //     return this.moderatorSummary
    //   default:
    //     return ''
    // }
    // },
    async fetchPropertyLogs() {
      await this.$store
        .dispatch('properties/fetchPropertyLogsAction', {
          page: this.options.page,
          limit: this.options.itemsPerPage,
          sortBy: this.options.sortBy,
          sortDesc: this.options.sortDesc
        })
        .then((data) => {
          this.propertyLogsTotal = data.count
          return data.data
        })
    }
  }
}
</script>

<style scoped>
.v-list.existing-page-roles-list {
  padding: 0;
}
.logo-img {
  transition: 0.3s ease;
}
#logo-trigger:hover .logo-img {
  opacity: 0.7;
}
.v-card.card-content {
  border-radius: 12px !important;
}
.v-menu__content {
  /*border-radius: 20px !important;*/
  box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.05),
    0px 8px 10px 1px rgba(0, 0, 0, 0.05), 0px 3px 14px 2px rgba(0, 0, 0, 0.1) !important;
}
.v-input {
  border-radius: 10px;
}
table tbody tr td {
  /*border: none !important;
    border-bottom: none !important;*/
  border-color: #eeeeee !important;
}
p {
  margin-bottom: 0;
}
</style>
